var Vue = require('vue');
var echarts = require('echarts');

module.exports = {
    deep: true,
    params: ['loading'],
    paramWatchers: {
        loading: function (val, oldVal) {
            var self = this;

            if (val === true) {
                self.instance.showLoading();
            } else {
                self.instance.hideLoading();
            }
        }
    },
    bind: function () {
        var self = this;

        Vue.nextTick(function () {
            // init echarts instance
            self.instance = echarts.init(self.el);

            // show loading animation
            if (self.params.loading === true) {
                self.instance.showLoading({
                    text: 'laden...',
                    color: '#ad1457',
                    textColor: '#7F4757'
                });
            }

            // auto resize
            var resizeEvent = new Event('resize');

            self.resizeEventHandler = function () {
                self.instance.resize();
            };

            self.el.addEventListener('resize', self.resizeEventHandler, false);

            window.onresize = function () {
                self.el.dispatchEvent(resizeEvent);
            };
        });
    },
    update: function (val, oldVal) {
        var self = this;
        var options = val;

        Vue.nextTick(function () {
            self.instance.setOption(options);
        });
    },
    unbind: function () {
        var self = this;

        self.instance.dispose();

        self.el.removeEventListener('resize', self.resizeEventHandler, false);
    }
};


// WEBPACK FOOTER //
// ./src/directives/echarts.js